import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * "1121  Bank – Main Account" — code in a fixed-width face, then the name.
 * Never wider than its container: a long name ends in an ellipsis instead of
 * running into the next column.
 */
const AccountLabel: React.FC<{ code: string; name: string; muted?: boolean; bold?: boolean }> = ({ code, name, muted, bold }) => (
  <Typography
    variant="body2" component="span" fontWeight={bold ? 600 : 400} color={muted ? 'text.disabled' : 'text.primary'} noWrap
    sx={{ display: 'inline-block', maxWidth: '100%', verticalAlign: 'bottom' }}
  >
    <Box component="span" sx={{ fontFamily: 'monospace', color: muted ? 'text.disabled' : 'text.secondary', mr: 1.25 }}>{code}</Box>
    {name}
  </Typography>
);

export default AccountLabel;
